"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const areValuesStrictlyEqual = (valueA) => (valueB) => {
    if (valueA === valueB) {
        return true;
    }
    if ((0, valueIsArray_1.default)(valueA)) {
        if (!(0, valueIsArray_1.default)(valueB) || valueB.length !== valueA.length) {
            return false;
        }
        for (let i = 0; i < valueA.length; i += 1) {
            const itemA = valueA[i];
            const itemB = valueB[i];
            if (!areValuesStrictlyEqual(itemA)(itemB)) {
                return false;
            }
        }
        return true;
    }
    if ((0, valueIsRecord_1.default)(valueA)) {
        const keysA = Object.keys(valueA);
        if (!(0, valueIsRecord_1.default)(valueB)) {
            return false;
        }
        const keysB = Object.keys(valueB);
        if (!areValuesStrictlyEqual(keysA)(keysB)) {
            return false;
        }
        for (let i = 0; i < keysA.length; i += 1) {
            const key = keysA[i];
            const itemA = valueA[key];
            const itemB = valueB[key];
            if (!areValuesStrictlyEqual(itemA)(itemB)) {
                return false;
            }
        }
        return true;
    }
    return false;
};
exports.default = areValuesStrictlyEqual;
